import { render, staticRenderFns } from "./imprimir-factura.vue?vue&type=template&id=20c3e78a&scoped=true&"
import script from "./imprimir-factura.vue?vue&type=script&lang=js&"
export * from "./imprimir-factura.vue?vue&type=script&lang=js&"
import style0 from "./imprimir-factura.vue?vue&type=style&index=0&id=20c3e78a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c3e78a",
  null
  
)

export default component.exports